import { render } from "./Contouring.vue?vue&type=template&id=d3f18e42"
import script from "./Contouring.vue?vue&type=script&lang=js"
export * from "./Contouring.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/drgeramiclinic-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__